/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/send': {
    width: 34,
    height: 30,
    viewBox: '0 0 34 30',
    data: '<path pid="0" d="M.994 13.557C3.019 8.519 8.488 6 17.4 6h4.2V1.2c0-.325.119-.606.356-.844.238-.237.519-.356.844-.356.325 0 .606.119.844.356l9.6 9.6c.238.238.356.52.356.845 0 .324-.118.606-.356.843l-9.6 9.6a1.155 1.155 0 01-.844.357c-.325 0-.606-.119-.844-.356a1.153 1.153 0 01-.356-.844v-4.8h-4.2c-1.225 0-2.322.037-3.29.112-.969.075-1.932.209-2.888.403-.957.194-1.788.46-2.494.797a8.828 8.828 0 00-1.978 1.303A6.534 6.534 0 005.25 20.11c-.387.732-.69 1.597-.91 2.597-.218 1-.327 2.131-.327 3.394 0 .687.031 1.456.093 2.306 0 .075.016.222.047.44.031.22.047.385.047.497a.7.7 0 01-.16.469.549.549 0 01-.44.187c-.2 0-.375-.106-.525-.319a2.145 2.145 0 01-.244-.412 42.014 42.014 0 01-.45-1.012C.794 24.695.001 21.876.001 19.8c0-2.488.33-4.57.993-6.244z" _fill="#fff"/>'
  }
})
